// extracted by mini-css-extract-plugin
export default {"flexCenter":"NameCardCell_flexCenter__Ff26I","img":"NameCardCell_img__4Iyvv","text":"NameCardCell_text__pTg53","clickable":"NameCardCell_clickable__u8uwE"};